import { GLOBAL_STATUS } from "./global-enums";
import { serverResponseConstants } from "../constants/serverResponse.constants";
import { authService } from "../services";
import { SCREEN_PATH } from "../constants";

//Destructing constants
const { NETWORK_ERROR, SERVER_ISSUE, SOMETHING_WENT_WRONG } =
  serverResponseConstants;

//Retrieves all error messages from an object of errors.
function allErrorMessages(errors) {
  let errorMessages = [];
  // eslint-disable-next-line
  Object.keys(errors).forEach((key) => {
    errorMessages.push(errors[key]);
  });
  return errorMessages;
}

//Function to handle http response from server and perform action accordingly
function handleHTTPResponses(httpResponse) {
  let errorMessages = [];
  if (httpResponse) {
    const { msg } = httpResponse.data;
    const responseStatus = httpResponse.status;
    if (responseStatus === GLOBAL_STATUS.FORBIDDEN) {
      setTimeout(() => {
        authService.logout().then(() => window.location.assign(SCREEN_PATH.LOGIN));
      }, 1000);
    }

    if (responseStatus !== GLOBAL_STATUS.SUCCESS) {
      if (httpResponse.data.errors) {
        errorMessages = allErrorMessages(httpResponse.data.errors);
      }
      errorMessages.unshift(msg);
      return Promise.reject(errorMessages);
    }
    return httpResponse;
  }
  errorMessages.push(SERVER_ISSUE);
  return Promise.reject(errorMessages);
}

//Function to handle action by server response text
function handleResponseByStatus(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  });
}

//Handles server response
function handleServerResponse(response) {
  const { status, msg, errors = [], data } = response;
  if (status === GLOBAL_STATUS.SUCCESS) {
    return { msg: data.msg, ...data.payload };
  }
  const Msg = () => (
    <div>
      <h4 className="m-0">{msg || SOMETHING_WENT_WRONG}</h4>
      {Object.keys(errors).map((key) => (
        <div key={key}>{errors[key]}</div>
      ))}
    </div>
  );
  return Promise.reject(Msg);
}

const responseHandler = {
  handleHTTPResponses,
  handleResponseByStatus,
  handleServerResponse,
};

export default responseHandler;
